import React, { useEffect } from "react";
import AOS from "aos"; // Import AOS
import "aos/dist/aos.css"; // Import AOS styles

// Data constant for education details with SVG paths
const educationData = [
    {
        id: 3,
        title: "Bachelor of Engineering (B.E) - Computer Science and Engineering",
        duration: "2023 - Present",
        institution: "New Horizon College Of Engineering, Bengaluru - KA",
        grade: "CGPA: 9.6",
        svgPath: (
            <svg
                className="w-2.5 h-2.5 text-blue-800"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
            >
                <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
            </svg>
        ),
    },
    {
        id: 2,
        title: "Higher Secondary Education (12th)",
        duration: "2022 - 2023",
        institution: "Munam Public School, Hazaribagh JH",
        grade: "Percentage: 83% - A2",
        svgPath: (
            <svg
                className="w-2.5 h-2.5 text-blue-800"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
            >
                <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
            </svg>
        ),
    },
    {
        id: 1,
        title: "Secondary Education (10th)",
        duration: "2020 - 2021",
        institution: "DAV Public School, Hazaribagh JH",
        grade: "Grade: A2",
        svgPath: (
            <svg
                className="w-2.5 h-2.5 text-blue-800 "
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
            >
                <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
            </svg>
        ),
    },
];

const Education = () => {
    useEffect(() => {
        AOS.init(); // Initialize AOS
    }, []);

    return (
        <div className="container mx-auto shadow rounded-lg my-8 px-10 py-5 ubuntu-regular">
            <h2 className="text-3xl font-bold text-left mb-8">Education</h2>
            <ol className="relative border-s border-gray-200">
                {educationData.map(
                    ({ id, title, duration, institution, grade, svgPath }) => (
                        <li key={id} className="mb-10 ms-6">
                            <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ">
                                {svgPath}
                            </span>
                            <h3
                                className="mb-1 text-lg font-semibold"
                                data-aos="fade-down"
                            >
                                {title}
                            </h3>
                            <time
                                className="block mb-1 text-sm font-normal leading-none opacity-10"
                                data-aos="fade-up"
                            >
                                {duration}
                            </time>
                            <p
                                className="text-base font-normal opacity-10"
                                data-aos="fade-up"
                            >
                                {institution} <br />
                                {grade}
                            </p>
                        </li>
                    )
                )}
            </ol>
        </div>
    );
};

export default Education;
